module.exports = __webpack_public_path__ + "img/zold_doboz_fehernyil.6748e06a.svg";